module.exports = __webpack_public_path__ + "static/media/landing-top-person-ex.2a41b2dc.png";